export const SITE_NAME = "LegioPro";
export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || "https://legiopro.co.uk";
export const CONTACT_EMAIL = "chris@legiopro.co.uk";
export const PHONE_UK = { display: "+44 (0) 7783 174142", href: "tel:+447783174142" };
export const PHONE_ROI = { display: "+353 87 033 6028", href: "tel:+353870336028" };
export const OWNER_NAME = "Christopher Baggley";
